var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStoreFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "app-store-full",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.664,
    height: 40,
    viewBox: "0 0 119.664 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    width: 119.664,
    height: 40,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2685",
    "data-name": "Group 2685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2684",
    "data-name": "Group 2684",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M110.135,0H9.535c-.367,0-.729,0-1.1,0-.306,0-.61.008-.919.013a13.334,13.334,0,0,0-2,.176,6.72,6.72,0,0,0-1.9.627A6.449,6.449,0,0,0,2,2,6.271,6.271,0,0,0,.82,3.618a6.6,6.6,0,0,0-.625,1.9,12.933,12.933,0,0,0-.18,2C.006,7.83,0,8.138,0,8.444V31.559c0,.31.006.611.015.921a12.91,12.91,0,0,0,.18,2A6.567,6.567,0,0,0,.82,36.387,6.2,6.2,0,0,0,2,38,6.282,6.282,0,0,0,3.616,39.18a6.729,6.729,0,0,0,1.9.631,13.6,13.6,0,0,0,2,.176c.309.007.613.011.919.011.366,0,.728,0,1.1,0h100.6c.359,0,.725,0,1.084,0,.305,0,.617,0,.922-.011a13.27,13.27,0,0,0,2-.176,6.827,6.827,0,0,0,1.908-.631A6.26,6.26,0,0,0,117.666,38a6.422,6.422,0,0,0,1.182-1.614,6.6,6.6,0,0,0,.619-1.905,13.428,13.428,0,0,0,.186-2c0-.31,0-.611,0-.921.008-.364.008-.725.008-1.094V9.536c0-.366,0-.729-.008-1.092,0-.306,0-.614,0-.921a13.44,13.44,0,0,0-.186-2,6.613,6.613,0,0,0-.619-1.9,6.465,6.465,0,0,0-2.8-2.8,6.786,6.786,0,0,0-1.908-.627,13.015,13.015,0,0,0-2-.176c-.305,0-.617-.011-.922-.013C110.86,0,110.494,0,110.135,0Z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M8.445,39.125c-.3,0-.6,0-.9-.011a12.575,12.575,0,0,1-1.869-.163A5.87,5.87,0,0,1,4.015,38.4a5.4,5.4,0,0,1-1.4-1.016A5.338,5.338,0,0,1,1.6,35.99a5.756,5.756,0,0,1-.543-1.657,12.406,12.406,0,0,1-.166-1.875c-.007-.211-.015-.913-.015-.913V8.444s.009-.691.015-.894a12.484,12.484,0,0,1,.165-1.872A5.759,5.759,0,0,1,1.6,4.016a5.36,5.36,0,0,1,1.015-1.4A5.581,5.581,0,0,1,4.014,1.6a5.843,5.843,0,0,1,1.654-.544A12.668,12.668,0,0,1,7.543.887l.9-.012H111.214l.913.013a12.321,12.321,0,0,1,1.859.162,5.953,5.953,0,0,1,1.67.548,5.589,5.589,0,0,1,2.415,2.42,5.784,5.784,0,0,1,.536,1.649,12.979,12.979,0,0,1,.173,1.887c0,.283,0,.588,0,.89.008.375.008.732.008,1.092V30.465c0,.363,0,.718-.008,1.075,0,.325,0,.623,0,.93a12.652,12.652,0,0,1-.17,1.853,5.771,5.771,0,0,1-.54,1.67,5.5,5.5,0,0,1-1.016,1.386,5.408,5.408,0,0,1-1.4,1.022,5.86,5.86,0,0,1-1.668.55,12.468,12.468,0,0,1-1.87.163c-.293.007-.6.011-.9.011l-1.084,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M24.769,20.3a4.949,4.949,0,0,1,2.357-4.152,5.067,5.067,0,0,0-3.992-2.158C21.455,13.815,19.827,15,18.972,15c-.873,0-2.19-.987-3.609-.958a5.314,5.314,0,0,0-4.473,2.728c-1.934,3.348-.491,8.269,1.361,10.976.927,1.325,2.01,2.806,3.428,2.753,1.387-.057,1.9-.884,3.579-.884s2.145.884,3.591.851c1.489-.024,2.426-1.331,3.321-2.669A10.964,10.964,0,0,0,27.688,24.7a4.782,4.782,0,0,1-2.919-4.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M22.037,12.211A4.874,4.874,0,0,0,23.152,8.72a4.96,4.96,0,0,0-3.208,1.66A4.637,4.637,0,0,0,18.8,13.741a4.1,4.1,0,0,0,3.237-1.53",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M42.3,27.14H37.569L36.432,30.5H34.427l4.484-12.418h2.083L45.477,30.5H43.438Zm-4.243-1.549h3.752l-1.85-5.447H39.91Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M55.16,25.97c0,2.813-1.507,4.621-3.778,4.621a3.07,3.07,0,0,1-2.85-1.584h-.043v4.484H46.632V21.443h1.8v1.506h.034a3.209,3.209,0,0,1,2.882-1.6c2.3,0,3.813,1.816,3.813,4.622m-1.91,0c0-1.833-.948-3.038-2.394-3.038-1.42,0-2.375,1.23-2.375,3.038,0,1.824.955,3.046,2.375,3.046,1.446,0,2.394-1.2,2.394-3.046",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M65.124,25.97c0,2.813-1.506,4.621-3.778,4.621A3.069,3.069,0,0,1,58.5,29.007h-.043v4.484H56.6V21.443h1.8v1.506h.034a3.212,3.212,0,0,1,2.883-1.6c2.3,0,3.812,1.816,3.812,4.622m-1.91,0c0-1.833-.947-3.038-2.393-3.038-1.42,0-2.375,1.23-2.375,3.038,0,1.824.955,3.046,2.375,3.046C62.267,29.016,63.214,27.82,63.214,25.97Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M71.711,27.036c.137,1.231,1.334,2.04,2.968,2.04,1.566,0,2.693-.809,2.693-1.919,0-.964-.68-1.541-2.289-1.936l-1.608-.388c-2.282-.551-3.34-1.617-3.34-3.348,0-2.142,1.868-3.614,4.518-3.614,2.624,0,4.423,1.472,4.484,3.614H77.261c-.113-1.239-1.137-1.987-2.633-1.987s-2.523.757-2.523,1.858c0,.878.655,1.395,2.255,1.79l1.369.336c2.547.6,3.607,1.626,3.607,3.443,0,2.323-1.852,3.778-4.795,3.778-2.754,0-4.613-1.421-4.732-3.667Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M83.346,19.3v2.143h1.722v1.471H83.346v4.991c0,.776.345,1.137,1.1,1.137A5.684,5.684,0,0,0,85.059,29v1.463a5.1,5.1,0,0,1-1.032.086c-1.833,0-2.548-.688-2.548-2.444v-5.19H80.162V21.443h1.317V19.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M86.065,25.97c0-2.849,1.677-4.639,4.294-4.639s4.295,1.79,4.295,4.639-1.662,4.639-4.295,4.639-4.294-1.783-4.294-4.639m6.695,0c0-1.954-.9-3.107-2.4-3.107s-2.4,1.162-2.4,3.107c0,1.962.895,3.106,2.4,3.106S92.76,27.932,92.76,25.97Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M96.186,21.443h1.772v1.541H98a2.161,2.161,0,0,1,2.178-1.636,2.905,2.905,0,0,1,.637.07v1.738a2.567,2.567,0,0,0-.835-.112,1.872,1.872,0,0,0-1.947,1.8,1.981,1.981,0,0,0,.01.288V30.5H96.186Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M109.384,27.837c-.25,1.644-1.85,2.772-3.9,2.772-2.634,0-4.269-1.765-4.269-4.6s1.644-4.682,4.191-4.682c2.505,0,4.08,1.721,4.08,4.466v.637h-6.395v.112a2.359,2.359,0,0,0,2.141,2.557,2.417,2.417,0,0,0,.295.008,2.05,2.05,0,0,0,2.091-1.274Zm-6.282-2.7h4.526a2.177,2.177,0,0,0-2.053-2.3c-.055,0-.111,0-.167,0a2.293,2.293,0,0,0-2.306,2.278v.02",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M37.827,8.731a2.639,2.639,0,0,1,2.821,2.444,2.593,2.593,0,0,1-.014.521c0,1.906-1.03,3-2.807,3H35.671V8.731ZM36.6,13.854h1.125a1.875,1.875,0,0,0,1.984-1.761,1.84,1.84,0,0,0-.016-.385,1.883,1.883,0,0,0-1.968-2.134H36.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M41.681,12.444a2.133,2.133,0,1,1,4.247,0,2.134,2.134,0,0,1-4.247.414,2.2,2.2,0,0,1,0-.414m3.333,0c0-.976-.438-1.547-1.208-1.547s-1.207.571-1.207,1.547.435,1.55,1.207,1.55S45.014,13.424,45.014,12.444Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M51.573,14.7h-.922l-.931-3.316h-.07L48.723,14.7H47.81l-1.241-4.5h.9l.807,3.436h.067l.925-3.436h.853l.926,3.436h.07l.8-3.436h.888Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M53.854,10.195h.854v.715h.067a1.349,1.349,0,0,1,1.344-.8,1.463,1.463,0,0,1,1.558,1.675V14.7h-.888V12.006c0-.724-.315-1.083-.972-1.083a1.032,1.032,0,0,0-1.08.983,1.044,1.044,0,0,0,.006.158V14.7h-.889Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 0.889,
    height: 6.261,
    transform: "translate(59.094 8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M61.218,12.444a2.134,2.134,0,0,1,4.248-.406,2.3,2.3,0,0,1,0,.406,2.134,2.134,0,0,1-4.248.413,2.192,2.192,0,0,1,0-.413m3.333,0c0-.976-.438-1.547-1.208-1.547s-1.207.571-1.207,1.547.435,1.55,1.207,1.55,1.208-.57,1.208-1.55",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M66.4,13.425c0-.811.6-1.278,1.675-1.344l1.22-.071v-.388c0-.476-.314-.745-.922-.745-.5,0-.84.183-.938.5h-.861c.091-.774.819-1.27,1.84-1.27,1.129,0,1.766.562,1.766,1.514V14.7h-.856v-.633h-.07a1.512,1.512,0,0,1-1.353.707,1.359,1.359,0,0,1-1.493-1.212c0-.045-.007-.09-.008-.135m2.895-.385v-.376l-1.1.07c-.62.041-.9.252-.9.649s.352.641.835.641a1.062,1.062,0,0,0,1.163-.949l0-.035",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M71.348,12.444c0-1.423.731-2.324,1.869-2.324a1.482,1.482,0,0,1,1.381.79h.066V8.437h.889V14.7H74.7v-.711h-.071a1.564,1.564,0,0,1-1.414.786c-1.145,0-1.869-.9-1.869-2.328m.918,0c0,.955.45,1.53,1.2,1.53s1.212-.583,1.212-1.526-.468-1.53-1.212-1.53S72.266,11.5,72.266,12.444Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M79.23,12.444a2.133,2.133,0,1,1,4.247,0,2.134,2.134,0,0,1-4.247.414,2.2,2.2,0,0,1,0-.414m3.333,0c0-.976-.438-1.547-1.208-1.547s-1.207.571-1.207,1.547.435,1.55,1.207,1.55,1.208-.57,1.208-1.55",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M84.669,10.195h.855v.715h.067a1.348,1.348,0,0,1,1.344-.8,1.463,1.463,0,0,1,1.558,1.675V14.7h-.888V12.006c0-.724-.315-1.083-.972-1.083a1.032,1.032,0,0,0-1.08.983,1.044,1.044,0,0,0,0,.158V14.7h-.889Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M93.515,9.074v1.142h.976v.748h-.976V13.28c0,.471.194.678.637.678a2.966,2.966,0,0,0,.339-.021v.741a3.026,3.026,0,0,1-.484.045c-.988,0-1.382-.348-1.382-1.216V10.964H91.91v-.748h.715V9.074Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M95.705,8.437h.881v2.481h.07a1.386,1.386,0,0,1,1.373-.806,1.483,1.483,0,0,1,1.562,1.4,1.533,1.533,0,0,1-.011.279V14.7h-.89V12.01c0-.719-.335-1.084-.963-1.084a1.053,1.053,0,0,0-1.134.963.973.973,0,0,0,0,.179V14.7h-.889Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M104.761,13.482a1.828,1.828,0,0,1-1.951,1.3,2.046,2.046,0,0,1-2.1-1.991,1.952,1.952,0,0,1,.019-.333,2.074,2.074,0,0,1,2.076-2.353c1.253,0,2.009.856,2.009,2.27v.31h-3.18v.05a1.19,1.19,0,0,0,1.086,1.286c.038,0,.075,0,.113,0a1.08,1.08,0,0,0,1.072-.546Zm-3.126-1.451h2.274a1.086,1.086,0,0,0-1-1.164q-.052,0-.1,0A1.153,1.153,0,0,0,101.635,12Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreFull);
export default __webpack_public_path__ + "static/media/app-store-full.e3d3f0a2ff9a482b1d5d46232af32d28.svg";
export { ForwardRef as ReactComponent };